import React from "react";
import { Asset } from "../../../Types";
import { UseDownloadAsset } from "../../../api/calls/Queries";
import AudioIconFile from "../../Icons/AudioFileIcon";
import ImagePopupIcons from "../../Icons/ImagePopupIcons";
import { getLanguageFile } from "../../common/GetLanguageFile";

const ListElement = (props: {
  assets: Asset[];
  setSelectedAsset: React.Dispatch<
    React.SetStateAction<number | string | undefined>
  >;
  selectedAsset: number | string | undefined;
  assetType: number | undefined;
}) => {
  const [filter, setFilter] = React.useState<string>("");
  const [oldest, setOldest] = React.useState<boolean>(false);

  const { assetType, assets, selectedAsset, setSelectedAsset } = props;

  const assetsSortedAndFiltered = React.useMemo(() => {
    return assets
      .filter((asset) =>
        asset.assetDescription.toLowerCase().includes(filter.toLowerCase())
      )
      .sort((a, b) => {
        if (oldest) return a.assetId - b.assetId;
        else return b.assetId - a.assetId;
      });
  }, [assets, filter, oldest]);

  return (
    <div className="file-list-page">
      <div className="file-list-header">
        <input
          id="asset-list"
          placeholder={getLanguageFile("overlapping_panel.search")}
          type="text"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />

        <button onClick={() => setOldest(!oldest)} className="sorter">
          {getLanguageFile("overlapping_panel.sort_by")}{" "}
          <b>
            {oldest
              ? getLanguageFile("overlapping_panel.oldest")
              : getLanguageFile("overlapping_panel.newest")}
          </b>
        </button>
      </div>
      <div className="files-grid">
        {assetType &&
          assetsSortedAndFiltered.map((asset) => (
            <div key={asset.assetId}>
              <ListEl
                assetType={assetType}
                selectedAsset={selectedAsset}
                asset={asset}
                onClick={() => {
                  if (selectedAsset === asset.assetId)
                    setSelectedAsset(undefined);
                  else setSelectedAsset(asset.assetId);
                }}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

const ListEl = (props: {
  assetType: number | undefined;
  asset: Asset;
  onClick: () => void;
  selectedAsset: number | string | undefined;
}) => {
  const { asset, onClick, selectedAsset, assetType } = props;

  const assetToUseAsThumb = React.useMemo(() => {
    if (assetType === 1) return asset.assetKeyThumb;
    else if (asset.assetKeyLow) return asset.assetKeyLow;
    else return asset.assetKeyFull;
  }, [asset, assetType]);

  const { data: thumbBlob } = UseDownloadAsset(assetToUseAsThumb);

  const thisAssetIsSelected = selectedAsset === asset.assetId;

  return (
    <div className="list-element">
      <div
        className="file-thumbnail-wrapper"
        style={{
          borderColor: thisAssetIsSelected ? "#2563eb" : "transparent",
        }}
        onClick={onClick}
      >
        {assetType !== 3 && (
          <>
            {thumbBlob ? (
              <img
                className="file-thumbnail"
                alt={"Thumbnail panoramica"}
                src={thumbBlob}
              />
            ) : (
              <ImagePopupIcons fill={"#fff"} width="5rem" height="5rem" />
            )}
          </>
        )}
        {assetType === 3 && (
          <div className="audio-icon-wrapper">
            <AudioIconFile color="white" width={"5rem"} height={"5rem"} />
          </div>
        )}
      </div>
      <p
        className="asset-desc"
        style={{
          fontWeight: thisAssetIsSelected ? 700 : 500,
        }}
      >
        {asset.assetDescription ||
          getLanguageFile("overlapping_panel.missing_file_name")}
      </p>
    </div>
  );
};

export default ListElement;
